const doc = [({"no":({"js":({"components":({"score_factor_groups":({"mood_simple_line_chart":({"tendency":"Tendens"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;